import { useEffect } from 'react';

/**
 * SEO Component - Updates document title and meta tags for each page
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {string} props.description - Page meta description
 * @param {string} props.keywords - Page keywords (comma separated)
 * @param {string} props.canonicalUrl - Canonical URL for the page
 * @param {string} props.ogImage - Open Graph image URL
 * @param {string} props.ogType - Open Graph type (default: website)
 */
export const SEO = ({
  title = 'Hobi Hub | Go Beyond Routine, Find Your Flow',
  description = 'Discover unique events and experiences that energize your day and elevate your lifestyle.',
  keywords = 'Hobi Hub, events, experiences, workshops, activities',
  canonicalUrl = 'https://hobi.co.in',
  ogImage = 'https://hobi.co.in/images/webclip.png',
  ogType = 'website'
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Helper function to update or create meta tag
    const updateMetaTag = (attribute, value, content) => {
      let element = document.querySelector(`meta[${attribute}="${value}"]`);
      if (element) {
        element.setAttribute('content', content);
      } else {
        element = document.createElement('meta');
        element.setAttribute(attribute, value);
        element.setAttribute('content', content);
        document.head.appendChild(element);
      }
    };

    // Update meta description
    updateMetaTag('name', 'description', description);
    updateMetaTag('name', 'keywords', keywords);

    // Update Open Graph tags
    updateMetaTag('property', 'og:title', title);
    updateMetaTag('property', 'og:description', description);
    updateMetaTag('property', 'og:image', ogImage);
    updateMetaTag('property', 'og:type', ogType);
    updateMetaTag('property', 'og:url', canonicalUrl);

    // Update Twitter tags
    updateMetaTag('name', 'twitter:title', title);
    updateMetaTag('name', 'twitter:description', description);
    updateMetaTag('name', 'twitter:image', ogImage);

    // Update canonical URL
    let canonicalElement = document.querySelector('link[rel="canonical"]');
    if (canonicalElement) {
      canonicalElement.setAttribute('href', canonicalUrl);
    } else {
      canonicalElement = document.createElement('link');
      canonicalElement.setAttribute('rel', 'canonical');
      canonicalElement.setAttribute('href', canonicalUrl);
      document.head.appendChild(canonicalElement);
    }

    // Cleanup on unmount - reset to default
    return () => {
      document.title = 'Hobi Hub | Go Beyond Routine, Find Your Flow';
    };
  }, [title, description, keywords, canonicalUrl, ogImage, ogType]);

  return null; // This component doesn't render anything
};

export default SEO;
